import {
    UPDATE_LOGIN_STATUS,
    LOGOUT,
    FETCH_USER_DATA,
    CLEAR_ERROR_MSG
} from '../ActionTypes'

const API_URL = process.env.API_URL

const updateLoginStatus = (json) => {
    return {
        type: UPDATE_LOGIN_STATUS,
        payload: json
    }
}

export const logout = () => {
    return {
        type: LOGOUT
    }
}

export const clearErrorMessage = () => {
    return {
        type: CLEAR_ERROR_MSG
    }
}

const updateUserData = (json) => {
    return {
        type: FETCH_USER_DATA,
        payload: json
    }
}

const fetchUserData = (token) => {
    return dispatch => {
        return fetch(`${API_URL}/auth/profile`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`
                }
            })
            .then(response => response.json())
            .then(json => dispatch(updateUserData(json.result)))
    }
}

export const login = ({ username, password }) => {
    return dispatch => {
        dispatch(clearErrorMessage())
        return fetch(`${API_URL}/auth/login`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    username,
                    password
                })
            }).then(response => response.json())
            .then(json => {
                if (json.success)
                    dispatch(fetchUserData(json.token))
                dispatch(updateLoginStatus(json))
            })
    }
}



// WEBPACK FOOTER //
// ./src/LoginPage/LoginPageActions.js